import { render, staticRenderFns } from "./integrations.vue?vue&type=template&id=1aa1cb1a&scoped=true&"
import script from "./integrations.vue?vue&type=script&lang=js&"
export * from "./integrations.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1aa1cb1a",
  null
  
)

export default component.exports